import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Headset(props: IconProps) {
  return (
    <IconSvg {...props} viewBox="0 0 20 20">
      <path
        d="M1.25 10V11.875V12.5H0V11.875V10C0 4.49219 4.45312 0 10 0C15.5078 0 20 4.49219 20 10V18.1641V18.7891H19.375L13.75 18.75V20H12.5H8.75H7.5V18.75V17.5V16.25H8.75H12.5H13.75V17.5L18.75 17.5391V10C18.75 5.19531 14.8047 1.25 10 1.25C5.15625 1.25 1.25 5.19531 1.25 10ZM12.5 18.125V17.5H8.75V18.75H12.5V18.125ZM3.75 8.75V13.75H6.25V8.75H3.75ZM2.5 7.5H3.75H6.25H7.5V8.75V13.75V15H6.25H3.75H2.5V13.75V8.75V7.5ZM13.75 8.75V13.75H16.25V8.75H13.75ZM16.25 7.5H17.5V8.75V13.75V15H16.25H13.75H12.5V13.75V8.75V7.5H13.75H16.25Z"
        fill="#03184E"
      />
    </IconSvg>
  );
}
